import React from 'react';
import { Section } from './Section';
import { XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const attempts = [{
  title: 'Cetes o pagarés bancarios',
  desc: 'Apenas cubre la inflación y no protege a tu familia si tú faltas.'
}, {
  title: 'Propiedades para rentar',
  desc: 'Implica impuestos, mantenimiento y falta de liquidez inmediata.'
}, {
  title: 'Fondo de ahorro de la empresa',
  desc: 'Es dejar tu jubilación en manos de un tercero que puede despedirte mañana.'
}, {
  title: 'Seguros de vida tradicionales',
  desc: 'Son un "gasto" si no mueres; tú necesitas un instrumento que te devuelva el capital.'
}];
export function FailedAttempts() {
  return <Section bg="navy-light" data-id="element-42">
      <div className="text-center mb-8 md:mb-16" data-id="element-43">
        <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6" data-id="element-44">
          Lo Que Ya Intentaste <br data-id="element-45" />
          <span className="text-gray-dark text-lg md:text-3xl" data-id="element-46">
            (Y Por Qué No Funcionó)
          </span>
        </h2>
        <div className="w-16 md:w-24 h-1 bg-gold mx-auto" data-id="element-47"></div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-48">
        {attempts.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1,
        duration: 0.5
      }} className="bg-navy p-5 md:p-8 rounded-xl md:rounded-2xl border border-white/5 hover:border-white/10 transition-colors" data-id="element-49">
            <div className="flex items-start gap-3 md:gap-4" data-id="element-50">
              <div className="mt-0.5 bg-red-500/10 p-1.5 md:p-2 rounded-full shrink-0" data-id="element-51">
                <XIcon className="w-5 h-5 md:w-6 md:h-6 text-red-500" data-id="element-52" />
              </div>
              <div data-id="element-53">
                <h3 className="text-lg md:text-xl font-bold text-white mb-1.5 md:mb-3" data-id="element-54">
                  {item.title}
                </h3>
                <p className="text-gray-light leading-relaxed text-sm md:text-base" data-id="element-55">
                  {item.desc}
                </p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}